import type { BlockLikert } from 'shared-types';

type LocaleData = BlockLikert['locales'][string];

const now = Date.now();

const defaultBlockData = {
  colormap: 'gradient' as const,
  pointsWeight: 0,
  showResponseRatesAfterSubmit: false,
  showResponseRatesAllowBeforeAnswer: false,
  showUserAnswersAverage: false
};

const translatable: LocaleData['translatable'] = {
  description: '',
  feedback: '',
  option_1: '',
  option_2: '',
  option_3: '',
  option_4: '',
  option_5: '',
  question_1: '',
  question_2: '',
  question_3: ''
};
const defaultLocaleData: LocaleData = { translatable };

const localePlaceholders = {
  description: '{{ locales.translatable.description }}' as const,
  feedback: '{{ locales.translatable.feedback }}' as const,
  options: [
    '{{ locales.translatable.option_1 }}' as const,
    '{{ locales.translatable.option_2 }}' as const,
    '{{ locales.translatable.option_3 }}' as const,
    '{{ locales.translatable.option_4 }}' as const,
    '{{ locales.translatable.option_5 }}' as const
  ],
  questions: [
    { id: now - 2, question: '{{ locales.translatable.question_1 }}' as const },
    { id: now - 1, question: '{{ locales.translatable.question_2 }}' as const },
    { id: now, question: '{{ locales.translatable.question_3 }}' as const }
  ]
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockLikertData: BlockLikert = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockLikert['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
